<script setup>
import { inject, ref } from 'vue'
import Draggable from 'vuedraggable'
import { MenuItem } from '@/Components/Navigation'

const items = inject('items')
const form = inject('form')

const props = defineProps({
  group: {
    type: String,
    required: false,
    default: 'builder',
  },
  parent: {
    type: Object,
    required: false,
    default: null,
  },
  section: {
    type: String,
    required: false,
    default: 'left',
  },
})

const emits = defineEmits(['update:modelValue'])

const value = defineModel()

const onMove = (e) => {
  const dragged = e.draggedContext.element
  const target = e.to.id
    ? items.value[e.to.id]
    : null

  if (dragged && target && !target.allowedChildren.includes(dragged.component)) {
    return false
  }
}

const onChildrenUpdated = (newItems, element, errorKey) => {
  element.items = newItems

  // if children change, attempt to forget error key
  form.forgetError(errorKey)

  // propagate change upward to trigger reactivity given that this
  // could be coming from a deeply nested array
  emits('update:modelValue', value.value)
}

const drag = ref(false)
</script>

<template>
  <Draggable
    item-key="id"
    tag="ul"
    :id="parent?.id"
    :group="{ name: group }"
    v-model="value"
    :move="onMove"
    handle=".cursor-move"
    class="divide-y"
    @start="drag = true"
    @end="drag = false"
  >
    <template #item="{ element }">
      <MenuItem
        :element="element"
        :parent="parent"
        :group="group"
        :section="section"
      >
        <template #children="{ errorKey }">
          <MenuItemList
            :modelValue="element.items"
            :group="group ? group : element.id"
            :parent="element"
            :section="section"
            @update:modelValue="(e) => onChildrenUpdated(e, element, errorKey)"
          />
        </template>
      </MenuItem>
    </template>
  </Draggable>
</template>
